// auth.js
import React, { useState, useEffect } from "react";
import { useAuth } from "./AuthContext";
import "../styles/styles.css";

const Auth = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);

  const { login } = useAuth();

  const API_BASE_URL = "https://otp-bakend.onrender.com";

  const validDepartments = ["SALES", "PM", "BDM", "USER MANAGEMENT", "ADMIN"];

  // Check for an existing token on component mount
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      validateToken(token);
    }
  }, []);

  const validateToken = async (token) => {
    try {
      const response = await fetch(`${API_BASE_URL}/protected`, {
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.ok) {
        const data = await response.json();
        login(data.user, token);
      } else {
        localStorage.removeItem("authToken");
      }
    } catch (error) {
      console.error("Token validation error:", error);
      localStorage.removeItem("authToken");
    }
  };

  const sendOtp = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        showMessage(data.message || "OTP sent successfully!", "success");
        setIsOtpSent(true);
      } else {
        showMessage(data.message || "Failed to send OTP. Please try again.", "error");
      }
    } catch (error) {
      showMessage("Network error. Please check your connection.", "error");
      console.error("Error sending OTP:", error);
    }
  };

  const verifyOtp = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp }),
      });

      const data = await response.json();

      if (response.ok) {
        const rawDepartment = data.user?.department;
        const normalizedDepartment = normalizeDepartment(rawDepartment);

        if (validDepartments.includes(normalizedDepartment)) {
          // Store the token in localStorage
          localStorage.setItem("authToken", data.token);
          login(data.user, data.token);
        } else {
          throw new Error(`Invalid department received: "${rawDepartment}"`);
        }
      } else {
        showMessage(data.message || "Invalid OTP. Please try again.", "error");
      }
    } catch (error) {
      showMessage(error.message || "An error occurred. Please try again.", "error");
      console.error("Error verifying OTP:", error);
    }
  };

  const normalizeDepartment = (department) => {
    if (Array.isArray(department)) {
      console.warn("Department is an array. Taking the first element:", department);
      department = department[0];
    }

    if (typeof department === "string") {
      return department.trim().toUpperCase();
    }

    console.error("Unexpected department type:", department);
    return "";
  };

  const showMessage = (msg, type) => {
    setMessage(msg);
    setMessageType(type);
    setTimeout(() => setMessage(""), 5000);
  };

  return (
    <div className="auth-container">
      {!isOtpSent ? (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            sendOtp();
          }}
        >
          <h2>Login</h2>
          {message && <p className={`message ${messageType}`}>{message}</p>}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit">Send OTP</button>
        </form>
      ) : (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            verifyOtp();
          }}
        >
          <h2>Enter OTP</h2>
          {message && <p className={`message ${messageType}`}>{message}</p>}
          <input
            type="text"
            placeholder="OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            required
          />
          <button type="submit">Submit OTP</button>
        </form>
      )}
    </div>
  );
};

export default Auth;